export const BRAND_COLORS = {
  primary: "#3b82f6",
  secondary: "#4da3ff",
  gradient: "linear-gradient(135deg, #3b82f6 0%, #4da3ff 100%)",
  gradientHover: "linear-gradient(135deg, #2563eb 0%, #3b82f6 100%)",
  glass: {
    bg: "rgba(255, 255, 255, 0.6)",
    bgDark: "rgba(30, 30, 30, 0.6)",
    border: "rgba(255, 255, 255, 0.2)",
    blur: "blur(12px)",
  }
};

export const BRAND_SHADOWS = {
  soft: "0 8px 32px rgba(26, 115, 232, 0.15)",
  hard: "0 12px 40px rgba(26, 115, 232, 0.3)",
};
